import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BaryCanonicalService {
  private router = inject(Router);
  private document = inject(DOCUMENT);

  constructor() {
    // S'abonner aux changements de route pour mettre à jour l'URL canonique
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router.url)
      )
      .subscribe(() => {
        this.updateCanonicalUrl();
      });
  }

  /**
   * Met à jour l'URL canonique en utilisant simplement origine + path
   */
  updateCanonicalUrl(): void {
    this.setCanonicalUrl(this.document.location.origin + this.document.location.pathname);
  }

  /**
   * Définit l'URL canonique dans le head du document
   */
  private setCanonicalUrl(url: string): void {
    // Rechercher la balise canonique existante
    let linkEl: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

    if (linkEl) {
      // Mettre à jour la balise existante
      linkEl.setAttribute('href', url);
    } else {
      // Créer une nouvelle balise
      linkEl = this.document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      linkEl.setAttribute('href', url);
      this.document.head.appendChild(linkEl);
    }
  }
}
